export enum SubApplicationType {
  Add = "add",
  Copy = "copy",
  Terminate = "terminate",
}
